import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';
import {AdminSortField as AdminSortFields} from 'src/openapi/admin/models/AdminSortField';

import type {AssignedUsersFilters, AssignedUsersSearchCriteria} from '../typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AdminSortField} from 'src/openapi/admin/models/AdminSortField';


export const assignedUsersStateSlice = getCachedTableStateSlice<
    AssignedUsersSearchCriteria,
    AdminSortField,
    AssignedUsersFilters
>('roleAssignedUsers', AdminSortFields.EMAIL);

export const assignedUsersStateActions = assignedUsersStateSlice.actions;
export const assignedUsersStateSelector:
CachedTableStateSelector<AssignedUsersSearchCriteria, AdminSortField, AssignedUsersFilters> =
    state => state.adminRights.assignedUsers.state;
